'use strict';

var $ = require('jquery');
var Actuations = require('../actuation/actuation.js');

// Constructor
var Dynamic = function() {
    $('.dynamics-modal__available-dynamics .dynamic').on('click touchstart', function () {
        if ($(this).hasClass('selected')) return true;
        $(this).addClass('selected');
        spawnDynamic($(this));
    });
};

function spawnDynamic(dynamic) {
    var selectedDynamicDiv = $('.dynamics-modal__selected-dynamics');
    var dynamicId = dynamic.attr('id').replace('item_', '');
    var dynamicName = dynamic.find('span.dynamic__name').text();
    var dynamicValue = dynamic.find('span.dynamic__value').text();
    var dynamicUnit = dynamic.find('span.dynamic__unit').text();
    var dynamicFunctions = dynamic.find('ul.dynamic__extra-functions');
    var dynamicActuation = dynamic.find('div.actuation');
    var hasActuation = dynamicActuation.length;
    var dynamicHTML = '<div class="dynamic-visual" id="visual_' + dynamicId + '">';
    dynamicHTML += '<div class="dynamic-visual__value">';
    dynamicHTML += '<span class="value">' + dynamicValue + '</span>';
    dynamicHTML += '<span class="unit">' + dynamicUnit + '</span>';
    dynamicHTML += '</div>';
    if (dynamicFunctions.length) {
        dynamicHTML += dynamicFunctions.prop('outerHTML');
    }
    dynamicHTML += '<div class="dynamic-visual__name"><p>' + dynamicName + '</p><i class="fa fa-times-circle"></i></div>';
    dynamicHTML += '</div>';

    selectedDynamicDiv.find('h2').hide();
    selectedDynamicDiv.append(dynamicHTML);

    if (hasActuation) {
        $('#visual_' + dynamicId).addClass('has-actuation');
        var actuation = dynamicActuation.clone();
        $('#visual_' + dynamicId + ' .dynamic-visual__value').append(actuation);
    }

    Actuations.init();
    $('.dynamic-visual__name').on('click touchstart', function (e) {
        removeDynamic($(this).parent());
    });

    var extraFunctionBtns = $('.dynamic__extra-functions a');
    extraFunctionBtns.on('click touchstart', function (e) {
        extraFunctionBtns.removeClass('success');
        extraFunctionBtns.removeClass('error');
        var $this = $(this);
        $this.addClass('loading');
        extraFunctionBtns.not('.loading').addClass('disabled');
        setTimeout(function() {
            var resultingStatus = Math.random() < 0.8 ? 'success' : 'error';
            $this.removeClass('loading');
            extraFunctionBtns.removeClass('disabled');
            $this.addClass(resultingStatus);
        }, 2000);
    });
}

function removeDynamic(dynamic) {
    var selectedDynamicDiv = $('.dynamics-modal__selected-dynamics');
    var dynamicId = dynamic.attr('id').replace('visual_', '');
    dynamic.remove();
    $('.dynamics-modal__available-dynamics #item_' + dynamicId).removeClass('selected');

    if (selectedDynamicDiv.find('.dynamic-visual').length === 0) {
        selectedDynamicDiv.find('h2').show();
    }
}

module.exports = Dynamic;
